<template>
  <div class="container">
    <main-title />
    <div class="card" v-loading="loading">
      <page-title :text="'学校报名'"></page-title>
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          size="medium"
          label-position="left"
        >
          <el-form-item label="学校名称" prop="agent_name">
            <el-input
              v-model="ruleForm.agent_name"
              placeholder="请输入学校公章上的全称"
            ></el-input>
			<div class="tips">同一个学校仅允许一位老师负责上传作品。请避免多个老师(家长)注册多个账户上传作品，以免影响后期评奖。</div>
          </el-form-item>
        <!--  <el-form-item label="学校类型" prop="is_sng">
             <el-radio v-model="ruleForm.is_sng" label="1">乡村少年宫学校</el-radio>
             <el-radio v-model="ruleForm.is_sng" label="0">其他学校</el-radio>
          </el-form-item> -->
          <el-form-item label="所属地区" prop="region_id">
            <el-select
              v-model="ruleForm.city"
              filterable
              placeholder="市"
			  @change="changeCity"
			  style="width: 240px;margin-right: 20px;"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
			<el-select
			  v-model="ruleForm.region_id"
			  filterable
			  placeholder="区/县"
			  style="width: 240px;"
			>
			  <el-option
			    v-for="item in countyList"
			    :key="item.id"
			    :label="item.name"
			    :value="item.id"
			  >
			  </el-option>
			</el-select>
          </el-form-item>
          <el-form-item label="负责教师" prop="contact_username">
            <el-input
              v-model="ruleForm.contact_username"
              placeholder="请输入代表学校负责活动对接的教师姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input
              v-model="contact_phone"
              placeholder="请输入代表学校负责活动对接的教师电话"
              maxlength="11"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="学校学段" prop="schoolType">
            <el-checkbox-group v-model="ruleForm.schoolType">
              <el-checkbox label="1" name="type" border>小学</el-checkbox>
              <el-checkbox label="10" name="type" border>初中</el-checkbox>
			  <el-checkbox label="100" name="type" border>高中</el-checkbox>
			  <el-checkbox label="1000" name="type" border>中职</el-checkbox>
              （可多选）
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="学生人数" prop="student_num">
            <el-input
              v-model="ruleForm.student_num"
              placeholder="请输入学校在读学生人数"
            ></el-input>
          </el-form-item>

         <!-- <el-form-item label="授权书" prop="authorization">
            <uploader
              placeholder="上传已填写授权书照片"
              @on-success="upSuccess"
              :file-list="fileList"
              @change="changeFun"
              :before-upload="beforeUpload"
              accept="image/jpeg,image/png"
            >
              <el-button
                class="download"
                slot="append"
                type="text"
                icon="el-icon-download"
                @click="toDownload"
                >下载授权书模板</el-button
              >
            </uploader>
          </el-form-item> -->
          <el-form-item>
            <div class="el-upload__tip">
              <i class="el-icon-warning-outline up_tip"  style="transform:rotate(180deg);"></i>
              <div class="up_text">
                <p>若存在分校情况，请备注为（xx校区）。</p>
                <!-- <p>
                  2. 授权书必须按照学校实体名称加盖公章，实体名称与公章不符，将无法通过审核。
                </p>
                <p>3. 请确保上传的授权书照片字迹清晰，章印完整。</p>
                <p>4. 上传授权书图片不得大于5M。</p> -->
              </div>
            </div>
          </el-form-item>
          <el-button
            round
            type="primary"
            class="submit"
            @click="toSign"
            >提交报名</el-button
          >
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getCounty,getCity,sign,getRegInfo } from "@/api/school.js";
import { telRule, numberRule } from "@/utils/rules.js";
// import uploader from "@/components/uploader";

export default {
  name: "mainPage",
  data() {
    return {
      loading:false,
      cityList: [],
	  countyList:[],
      contact_phone: window.localStorage.getItem("phone"),
      ruleForm: {
        agent_name: "",
        // is_sng:"",
        region_id: "",
        contact_username: "",
        type: "",
        schoolType: [],
        student_num: "",
        authorization: "",
      },
      rules: {
        agent_name: [
          { required: true, message: "请输入学校公章上的全称", trigger: "blur" },
        ],
        // is_sng: [
        //   { required: true, message: "请选择是否乡村少年宫学校", trigger: "blur" },
        // ],
        region_id: [
          { required: true, message: "请选择所属区县", trigger: "change" },
        ],
        contact_username: [
          { required: true, message: "请输入负责教师姓名", trigger: "blur" },
        ],
        // contact_phone: [
        //   {
        //     required: true,
        //     validator: this.telRule,
        //     trigger: "blur",
        //     words: "联系电话",
        //   },
        // ],
        student_num: [
          {
            required: true,
            validator: this.numberRule,
            trigger: "blur",
            words: "学生人数",
            min: 1,
          },
        ],
        authorization: [
          { required: true, message: "请上传授权书", trigger: "change" },
        ],
        schoolType: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个学段",
            trigger: "change",
          },
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" },
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }],
      },
      fileList: [],
    };
  },
  watch: {
    "ruleForm.schoolType"(val) {
      if (val.length == 1) {
        this.ruleForm.type = Number(val[0]);
      } else if (val.length == 2) {
        this.ruleForm.type = Number(val[0]) +Number(val[1]);
      } else if (val.length == 3) {
        this.ruleForm.type = Number(val[0]) + Number(val[1]) + Number(val[2]);
      } else if (val.length == 4) {
        this.ruleForm.type = Number(val[0]) + Number(val[1]) + Number(val[2]) + Number(val[3]);
      } else{
		  this.ruleForm.type = ''
	  }
    },
  },
  created() {
    this.getCity();
    this.getRegInfo();
    // this.aliOss();
  },
  methods: {
    getRegInfo(){
      this.loading = true;
      getRegInfo().then(d=>{
        this.loading = false
        this.ruleForm = {...this.ruleForm,...d.data};
        this.ruleForm.authorization &&
        this.fileList.push({
          status:'success',
          name:this.ruleForm.authorization,
          url:this.ruleForm.authorization
        })
		this.renderTypes(this.ruleForm.type);
		if(d.data.region_id){
			const city = d.data.region_info.city;
			this.ruleForm.city = city;
			this.getCounty(city);
		}
      }).catch(e=>{
        this.loading = false
      })
    },
	renderTypes(type){
		let val = type.toString();
		if (val.length > 0 && type != 0){
			let arr = val.split('').reverse()
			this.ruleForm.schoolType =  [
				arr[0] === '1' ? '1' : '',
				arr[1] === '1' ? '10' : '',
				arr[2] === '1' ? '100' : '',
				arr[3] === '1' ? '1000' : ''
			]
		}else{
			this.ruleForm.schoolType = []
		}
	},
    toDownload(){
      window.location.href="http://sdb-oss.new-class.cn/tongsheng/%E6%8E%88%E6%9D%83%E4%B9%A6-%E5%AD%A6%E6%A0%A1%EF%BC%88%E4%B9%A1%E6%9D%91%E5%B0%91%E5%B9%B4%E5%AE%AB%EF%BC%89.doc"
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      return isLt2M;
    },
    changeFun(file){
    },
	
    getCity() {
      getCity({ pid: 610000 }).then((d) => {
        this.cityList = d.data;
      });
    },
	getCounty(pid) {
	  getCounty({ pid }).then((d) => {
	    this.countyList = d.data;
	  });
	},
	changeCity(pid){
		this.ruleForm.region_id = '';
		this.getCounty(pid)
	},
    toUpload() {
      this.$refs.upload.submit();
    },
    telRule(rule, value, callback) {
      telRule(rule, value, callback);
    },
    numberRule(rule, value, callback) {
      numberRule(rule, value, callback);
    },
    upSuccess(data) {
      this.ruleForm.authorization =
        data.fileList.length > 0 ? data.fileList[0].filePath : "";
    },
    toSign(){
        this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$showLoading();
		  const {region_info,schoolType,...formData} = this.ruleForm;
          sign(formData).then(d=>{
            window.localStorage.setItem("name",this.ruleForm.agent_name)
            this.$router.push({ path: "/info", query: { status:0 } });
          })
        }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.form {
  margin: 40px auto;
  width: 600px;
  .download {
    margin-left: 20px;
    font-size: 16px;
    text-decoration: underline;
  }
  .el-upload__tip {
    font-size: 14px;
    color: #262626;
    line-height: 24px;
    .up_tip {
      float: left;
      font-size: 26px;
      color: #bc463b;
    }
    .up_text {
      overflow: hidden;
    }
    p {
      margin: 0;
      margin-left: 30px;
      text-indent: -1.1em;
    }
  }
  .submit {
    display: block;
    margin: 20px auto 0;
    width: 260px;
  }
}
.tips{
	font-size: 14px;
	color: red;
	line-height: 20px;
	padding-top: 10px;
}
</style>
<style lang="scss">
.download {
  i {
    font-size: 20px;
    vertical-align: middle;
    font-weight: 700;
  }
}
</style>